import API from './api';
import CacheService from './cacheService';

const DEFAULT_CACHE_DURATION = 5000; // 5 seconds
const SELECTOR_STOCK_CACHE_DURATION = 600000; // 10 minutes
const SELECTOR_CACHE_DURATION = 120000; // 2 minutes

const resolveCacheDuration = (url, params = {}, cacheDuration) => {
    if (cacheDuration != null) return cacheDuration;

    const noCache = params.params?.noCache;
    if (noCache === true || noCache === 'true') {
        return 0;
    }

    if (params.params?.selector) {
        return url.includes('stock') ? SELECTOR_STOCK_CACHE_DURATION : SELECTOR_CACHE_DURATION;
    }

    return DEFAULT_CACHE_DURATION;
};

const CachedApi = {
    get: (url, params = {}, { cacheDuration } = {}) => {
        const duration = resolveCacheDuration(url, params, cacheDuration);
        const key = JSON.stringify({ url, params });

        const cachedResponse = CacheService.fetch(key);
        if (cachedResponse) {
            console.log(`Cache: returning cached response for ${url}`);
            return Promise.resolve(cachedResponse);
        }

        const requestPromise = API.get(url, params)
            .then((response) => {
                CacheService.store(key, response, duration);
                return response;
            })
            .catch((error) => {
                CacheService.remove(key);
                return Promise.reject(error);
            });

        CacheService.store(key, requestPromise, duration);

        return requestPromise;
    }
};

export default CachedApi;
